var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskmeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.37 74.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0d6efd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.35,37.19c0,17.21-13.95,31.16-31.16,31.16S6.02,54.4,6.02,37.19,19.97,6.02,37.19,6.02c3.27,0,6.41,.5,9.37,1.44,1.55-1.53,3.17-3.1,4.84-4.64-4.38-1.81-9.18-2.82-14.21-2.82C16.65,0,0,16.65,0,37.19s16.65,37.19,37.19,37.19,37.19-16.65,37.19-37.19h-6.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32.37 52.66 15.69 35.98 21.35 30.32 32.37 41.34 63.17 10.54 68.83 16.2 32.37 52.66"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskmeIcon);
export default __webpack_public_path__ + "static/media/taskme-icon.5181f234d835736ff0668eabbbb9dbc8.svg";
export { ForwardRef as ReactComponent };